import Application from "../../Application";

export default function() {
    Application.Google.init();
    $('.btn-edit-move').tooltip();
    $('.anteprima_bee').tooltip();
    $('.invia_gc').tooltip();
    $('.dettagli_gc').tooltip();

    $(document).on('google-auth-granted', function(){
        // TODO: Application.Google.syncAllThreads();
    });

    $('#campagna').on('change', function() {
        var azioni = $('#campagna option:selected').data('azioni');
        $('#azione').html(' <option value="">-- Scegli azione --</option>');
        $.each(azioni, function(i,val) {
            $('#azione').append('<option value="'+val.TIniAz_Codice+'">'+val.TIniAz_Descriz+'</option>');
        })
    });

    $('.dettaglio_gc').on('click', function() {
        var id_lettera = $(this).data('id-lettera');

        $.ajax({
            url:'/ajax/statoInvioGraphicsCalve/'+id_lettera,
            method:'GET',
            beforeSend: function()
            {
                $('.loader-container').removeClass('d-none');
            },
            success:function(response) {
                $('#status_gs_container').html(response);
                $('#modal-satus-gc').modal('show');
                $('.loader-container').addClass('d-none');
            },
            error : function() {
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Errore',
                    text: 'Si è verificato un problema',
                    icon: 'warning',
                });
            }
        })
    })

    $('.invia_gc').on('click', function() {
        var off_codice = $(this).data('off-codice');
        var id_mossa = $(this).data('id-mossa');
        $.ajax({
            url:'/ajax/getIndirizzoModal/'+id_mossa,
            method:'GET',
            success:function(response) {
                $('#indirizzo_modal_container').html(response);
                $('#modal_indirizzo').modal('show');
                var pixel = parseFloat(getComputedStyle(document.documentElement).fontSize);
                var iframeHeight = $('.body-indirizzo').height()-(pixel*2);
                $('#anteprima_lettera').height(iframeHeight+'px');
            }
        })
    })

    $(window).on('resize', function() {
        var pixel = parseFloat(getComputedStyle(document.documentElement).fontSize);
        var iframeHeight = $('.body-indirizzo').height()-(pixel*2);
         $('#anteprima_lettera').height(iframeHeight+'px');

         var iframeHeight2 = $('.body-anteprima').height()-(pixel*2);
        $('#vedi_lettera').height(iframeHeight2+'px');
    })

    $(document).on('submit','#form_indirizzo', function(e) {
        e.preventDefault();
        Swal.fire({
            title: 'Inviare a GraphicScalve',
            text: 'Attenzione la lettera sarà inviata GraphicScalve per la stampa',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'SI',
            cancelButtonText: 'NO'
        }).then(function (result) {
            if (result.value) {
                $.ajax({
                    url: '/ajax/inviaGraphicsCalve',
                    method: 'POST',
                    data: $('#form_indirizzo').serialize(),
                    dataType:'JSON',
                    beforeSend: function() {
                        $('.loader-container').removeClass('d-none');
                    },
                    success: function(response){
                        if(response.success){
                            Swal.fire({
                                title: 'Operazione riuscita',
                                text: 'Documento inviato con successo',
                                icon: 'success',
                            });
                            $('#modal_indirizzo').modal('hide');
                            $('.btn-edit-move').addClass('d-none');
                        } else {
                            Swal.fire({
                                title: 'Si è verificato un problema',
                                text: response.message,
                                icon: 'error',
                            });
                        }

                        $('.loader-container').addClass('d-none');
                    },
                    error: function(error){
                        $('.loader-container').addClass('d-none');
                        Swal.fire({
                            title: 'Si è verificato un problema',
                            text: 'Non è stato possibile inviare il documento',
                            icon: 'error',
                        });
                    },
                });
            }
        });
    });


    $('#azione').on('change',function(){
        $.ajax({
            url:'/ajax/getLotti',
            method:'POST',
            dataType:'JSON',
            data:'campagna='+$('#campagna').val()+'&azione='+$('#azione').val(),
            success: function(response) {
                console.log(response);
                $('#lotto').html('<option value="">-- Scegli lotto --</option>');
                $.each(response, function(i,val) {
                    $('#lotto').append('<option value="'+val.TLotti_Codice+'">'+val.TLotti_Descrizione+ ' - (' + val.TLotti_Codice + ')</option>');
                });
            }
        })
    })

    $(document).on('click', '.manage-gmail-quote', function(e){
        e.stopPropagation();
        $(this).parent().find('.gmail_quote').animate({
            height: "toggle"
        })
    })

    $(document).on('show.bs.modal', '#modal-new-move, #modal-new-task', function (e) {
        $(this).find('input[type="text"]').val('');
        $(this).find('textarea').val('');
        $(this).find('select').val('');
    });

    $(document).on('click', '.bubble-btn', function (e) {
        $(this).parent().parent().toggleClass('editing');
    });
    $(document).on('click', '.task-container .label-status', function(){
        let myModal = new bootstrap.Modal(document.getElementById('modal-task-status'));
        let task_id = $(this).closest('.task-container').data('task-id');
        $("#task-id").val(task_id)
        myModal.show();
    });
    $(document).on('click', '.new-email', function(){
        let taskId = $(this).parent().parent().parent().data("task-id");
        $('#modal-email').removeClass('opacity-0');
        $('[name="email_task_id"]').val(taskId);
    });
    $(document).on('click', '.btn-send-sms', function(){
        let taskId = $(this).parent().data("task-id");
        $('#modal-sms').removeClass('opacity-0');
        $('[name="sms_task_id"]').val(taskId);
    })
    $(document).on('click', '.send-email', function(){
        Application.Google.sendEmail({
            subject: $('[name="email-title"]').val(),
            to: $('[name="email-receiver"]').val(),
            body: $('[name="email-text"]').val()
        });
    });
    $(document).on('click', '.send-sms', function(){
        $('#modal-sms .form-loader').removeClass('d-none');
        $.ajax({
            'url': '/ajax/send-sms',
            'method': 'POST',
            'data': {
                'sms': 1,
                'task-id': $('[name="sms_task_id"]').val(),
                'phone-number': $('[name="sms-number"]').val(),
                'note': $('[name="sms-text"]').val(),
            },
            success: function(result){
                if(result.success){
                    location.reload();
                } else {
                    $('#modal-sms .form-loader').addClass('d-none');
                }
            },
            error: function(error){
                $('#modal-sms .form-loader').addClass('d-none');
            }
        });
    });
    $(document).on('click', '.thread-visibility-manager', function(){
        let threadId = $(this).parent().parent().data("thread-id");
        if($(this).parent().parent().hasClass('open')){
            $(this).parent().parent().removeClass('open');
        } else {
            $(this).parent().parent().addClass('open');
            Application.Google.getThread({
                'threadId': threadId,
                'try': true
            });
        }
    })
    $(document).on('click', '.btn-group-status-options .status-option', function(){
        $.ajax({
            'url': '/ajax/update-status-task',
            'method': 'POST',
            'data':{
                'id_status': $(this).data("status"),
                'id_task': $("#task-id").val()
            },
            success: function(response){
                if(response.success){
                    location.reload();
                } else {
                    if(response.flag_no_moves){
                        Swal.fire({
                            title: 'Si è verificato un problema',
                            text: 'Non è stato possibile modificare lo stato del task perché non vi sono azioni, si prega di inserire una azione prima di procedere nuovamente.',
                            icon: 'warning',
                        });
                    }
                }
            },
            error: function(error){

            }
        })
    });

    $('input[name="dates"]').daterangepicker({
        locale: {
            format: 'DD/MM/YYYY',
            applyLabel: 'Applica',
            cancelLabel: 'Annulla',
            fromLabel: 'Da',
            toLabel: 'A',
            customRangeLabel: 'Custom',
            daysOfWeek: [
                'Dom',
                'Lun',
                'Mar',
                'Mer',
                'Gio',
                'Ven',
                'Sab'
            ],
            monthNames: [
                'Gennaio',
                'Febbraio',
                'Marzo',
                'Aprile',
                'Maggio',
                'Giugno',
                'Luglio',
                'Agosto',
                'Settembre',
                'Ottobre',
                'Novembre',
                'Dicembre'
            ],
            firstDay: 1
        }
    });

    $(document).on('click', '.task-container .btn-backend', function(){
        let taskId = $(this).closest('.task-container').data('task-id');
        $('#modal-new-move input[name="task-id"]').val(taskId);
        $('#modal-promessa input[name="task-id"]').val(taskId);
    });

    $(document).on('click', '#create-task .btn-backend', function(){
        $('#modal-new-task .form-loader').removeClass('d-none');
        $('#create-task').addClass('d-none');
        $.ajax({
            'url': '/ajax/create-task',
            'method': 'POST',
            'data': $('#create-task').serialize(),
            success: function(response){
                if(response.success){
                    $('#modal-new-task .btn-close').trigger('click');
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai creato con successo un nuovo task',
                        icon: 'success',
                    });
                    location.reload();
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile inserire il task',
                        icon: 'error',
                    });
                }
                $('#modal-new-task .form-loader').addClass('d-none');
                $('#create-task').removeClass('d-none');
            },
            error: function(error){
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile inserire il task',
                    icon: 'error',
                });
                $('#modal-new-task .form-loader').addClass('d-none');
                $('#create-task').removeClass('d-none');
            },
        });
    });

    $(document).on('click', '#create-move .btn-backend', function(){
        $('#modal-new-move .form-loader').removeClass('d-none');
        $('#create-move').addClass('d-none');

        if ($('#create-move').find('[name="note"]').val() == '')
        {
            Swal.fire({
                title: 'Attenzione',
                text: 'Il campo note è obbligatorio',
                icon: 'warning',
            });

            $('#create-move').addClass('d-none');
            return;
        }

        $.ajax({
            'url': '/ajax/create-move',
            'method': 'POST',
            'data': $('#create-move').serialize(),
            success: function(response){
                if(response.success){
                    $('#modal-new-move .btn-close').trigger('click');
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai creato con successo una nuova azione',
                        icon: 'success',
                    });
                    location.reload();
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile inserire l\'azione',
                        icon: 'warning',
                    });
                }
                $('#modal-new-move .form-loader').addClass('d-none');
                $('#create-move').removeClass('d-none');
            },
            error: function(error){
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile inserire l\'azione',
                    icon: 'error',
                });
                $('#modal-new-move .form-loader').addClass('d-none');
                $('#create-move').removeClass('d-none');
            },
        });
    });

    $(document).on('click', '#modal-promessa .btn-backend', function(){
        $('#modal-promessa .form-loader').removeClass('d-none');

        if ($('#modal-promessa').find('[name="note"]').val() == '')
        {
            Swal.fire({
                title: 'Attenzione',
                text: 'Il campo note è obbligatorio',
                icon: 'warning',
            });
            
            $('#modal-promessa .form-loader').addClass('d-none');
            return;
        }

        if ($('#modal-promessa').find('[name="importo"]').val() == '')
        {
            Swal.fire({
                title: 'Attenzione',
                text: 'Il campo importo è obbligatorio',
                icon: 'warning',
            });
            
            $('#modal-promessa .form-loader').addClass('d-none');
            return;
        }

        if (
            $('#modal-promessa').find('[name="importo"]').val() != '' &&
            isNaN($('#modal-promessa').find('[name="importo"]').val())
        )
        {
            Swal.fire({
                title: 'Attenzione',
                text: 'Il campo importo deve essere un numero',
                icon: 'warning',
            });
            
            $('#modal-promessa .form-loader').addClass('d-none');
            return;
        }

        $('#create-move-promessa').addClass('d-none');
        $('#modal-promessa .form-loader').removeClass('d-none');
        $.ajax({
            'url': '/ajax/create-move',
            'method': 'POST',
            'data': {
                evento:'0',
                promessa:'1',
                'task-id': $('[name="task-id"]').val(),
                fonte:$('#fonte').val(),
                campagna: $('#campagna').val(),
                azione: $('#azione').val(),
                lotto: $('#lotto').val(),
                progetto: $('#progetto').val(),
                importo: $('[name="importo"]').val(),
                note:$('#modal-promessa').find('[name="note"]').val(),
                off_codice: $('#modal-promessa').find('[name="off_codice"]').val(),
                data_scadenza: $('[name="expiring_date"]').val()
            },
            success: function(response){
                if(response.success){
                    $('#modal-new-move .btn-close').trigger('click');
                    $('#modal-promessa').modal('hide');
                    
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai creato con successo una nuova promessa',
                        icon: 'success',
                    });
                    location.reload();
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile inserire l\'azione',
                        icon: 'error',
                    });
                }
                $('#create-move-promessa').addClass('d-none');
                $('#modal-promessa .form-loader').removeClass('d-none');
            },
            error: function(error){
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile inserire l\'azione',
                    icon: 'error',
                });
                $('#create-move-promessa').addClass('d-none');
                $('#modal-promessa .form-loader').removeClass('d-none');
            },
        });
    });

    

    $(document).on('click', '.btn-edit-move', function(){
        const moveContainer = $(this).parent().parent().parent();
        var lettera = $(moveContainer).data('lettera');

        if (lettera == 'N') {
            moveContainer.toggleClass('editing');
            let flag_editable = moveContainer.find('.move-content').attr('contenteditable');
            if(flag_editable == 'true'){ moveContainer.find('.move-content').attr('contenteditable', 'false'); }
            else { moveContainer.find('.move-content').attr('contenteditable','true'); }
        } else {
            var task = $(moveContainer).data('task-id');
            var mossa_id = $(moveContainer).data('id');
            window.location.href='/admin/lettera/'+task+'/'+mossa_id;
        }
    });


    $(document).on('click','.anteprima_bee', function() {
        var id = $(this).data('item-id');

        $.ajax({
            url:'/ajax/vediLettera/'+id,
            method:'GET',
            beforeSend: function()
            {
                $('.loader-container').removeClass('d-none');
            },
            success:function(response) {
                $('#vedi_lettera').attr('src', response.url+'#view=FitH');
                $('.loader-container').addClass('d-none');
                $('#modal_anteprima').modal('show');
                var pixel = parseFloat(getComputedStyle(document.documentElement).fontSize);
                var iframeHeight = $('.body-anteprima').height()-(pixel*2);
                $('#vedi_lettera').height(iframeHeight+'px');
            },
            error : function() {
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Errore',
                    text: 'Si è verificato un problema',
                    icon: 'warning',
                });
            }
        });        
    })

    $('.scrivi_lettera').on('click', function() {
        var task_id = $(this).parent().data('task-id')
        window.location.href='/admin/lettera/'+task_id;
    });


    
    $(document).on('click', '.btn-save-move', function(){
        let data = {
            'id-move': $(this).parent().parent().data('id'),
            'new-note': $(this).parent().parent().find('.move-content').text(),
            'evento' : '0'
        };
        $.ajax({
            'url': '/ajax/edit-move',
            'method': 'POST',
            'data': data,
            success: function(response){
                if(response.success){
                    location.reload();
                }  else {
                    Swal.fire("Errore", "Errore durante l'aggiornamento della nota", "warning");
                }
            },
            error: function(error){
                Swal.fire("Errore", "Errore durante l'aggiornamento della nota", "error");
            }
        })
    });
    $(document).on('click', '.btn-reply-gmail', function(e){
        let body = $(this).parent().parent().find("textarea").val();
        $(this).parent().parent().find("textarea").val('');
        Application.Google.replyEmail({
            threadId: $(this).parent().parent().parent().data('thread-id'),
            body: body
        });
    });
    $(document).on('click', '[data-bs-target="#modal-contact"]', function(){
        $('[name="contact_task_id"]').val($(this).data("task-id"));
    });
    $(document).on('click', '.send-email-textbox', function(e){
        e.stopPropagation();
    });
    $(document).on('click', '.btn-create-hangout', function(){
        Application.Google.initCalendarModal({
            createHangout: true,
            taskId: $(this).parent().data('task-id')
        });
    });
    $(document).on('click', '.btn-create-c-event', function(){
        Application.Google.initCalendarModal({
            taskId: $(this).parent().data('task-id')
        });
    });
    $(document).on('change', '#attached-file', function(){
        var selectedFile = $(this).prop("files");
        //Check File is not Empty
        if (selectedFile.length > 0) {
            // Select the very first file from list
            var fileToLoad = selectedFile[0];

            $('.attachment-file-name').text(fileToLoad.name);
            $('.attachment-file-size').text(fileToLoad.size + ' bytes');

            $(this).parent().addClass('has-file')
            // FileReader function for read the file.
            var fileReader = new FileReader();
            let result;
            let base64file;
            // Onload of file read the file content
            fileReader.onload = function(fileLoadedEvent) {
                result = fileLoadedEvent.target.result;
                result = result.split(",");
                base64file = result[1];
                console.log(base64file);
            };
            // Convert data to base64
            fileReader.readAsDataURL(fileToLoad);
        }
    });
    $(document).on('change', '[name="toggle-type-contact"]', function(){
        if($(this).is(':checked')){
            $('.container-search-contact').addClass('d-none');
            $('.container-create-contact').removeClass('d-none');
        } else {
            $('.container-create-contact').addClass('d-none');
            $('.container-search-contact').removeClass('d-none');
        }
    });
    $(document).on('click', '#modal-contact .btn-backend', function(){
        const form = document.getElementById("create-new-contact");
        var formData = new FormData(form);
        formData.append("task-id", $('[name="contact_task_id"]').val());
        formData.append("is_contact", 1);
        if($('[name="toggle-type-contact"]').is(':checked')){
            formData.append("note", $('[name="contact_type_name"]').val());
        } else {
            formData.append("note", $("#contact_type option:selected").text());
        }
        $('#modal-contact .form-loader').removeClass("d-none");
        $('#create-new-contact').addClass('d-none');
        $.ajax({
            'url': '/ajax/create-contact',
            'method': 'POST',
            'data': formData,
            'processData': false,
            'contentType': false,
            success: function(response){
                $('#modal-contact .form-loader').addClass("d-none");
                if(response.success){
                    $("#modal-contact .btn-close").trigger("click");
                    location.reload();
                }
                $('#create-new-contact').removeClass('d-none');
            },
            error: function(err){
                $('#modal-contact .form-loader').addClass("d-none");
                $('#create-new-contact').removeClass('d-none');
            }
        });
    });
    $(document).on('click', '.task-in-calendar', function(){
        $.ajax({
            url:'/ajax/getEvento/'+$(this).data('event-internal-id'),
            method:'GET',
            dataType:'JSON',
            success:function(response) {
                openModal(response);
            }
        })
        // Application.Google.setupModalEvent({ "event_id" : $(this).data('event-id'), "move_id": $(this).data('id') });
    });

    $('#signout_button').on('click', function() {
        handleSignoutClick();
    });

    $('#signin_button').on('click', function() {
        handleAuthClick();
    });

    $(document).on('google-auth-granted', function(){
        $('#signin_button').addClass('none');
        $('#signout_button').removeClass('none');
    });
}

function handleSignoutClick() {
    const token = gapi.client.getToken();
    if (token !== null) {
        google.accounts.oauth2.revoke(token.access_token);
        Cookies.set("gapi_token", '');
        gapi.client.setToken('');
        $('#signin_button').removeClass('d-none');
        $('#signout_button').addClass('d-none');
    }
}

function handleAuthClick() {

    tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
            throw (resp);
        }

        Cookies.set("gapi_token", gapi.client.getToken().access_token);
        $('#signin_button').addClass('d-none');
        $('#signout_button').removeClass('d-none');     
    };

    if (gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({prompt: ''});
    }
}

async function openModal(response){
    if(!response.evento.organizzatore){
        // ci deve essere un organizzatore
        return;
    }
    $('.container-organizer').text(response.evento.organizzatore);
    $('#organizzatore').val(response.evento.organizzatore);
    $('input[name="event_id"]').val(response.evento.id_evento);
    $('input[name="task_id"]').val(response.evento.id_task);
    $('input[name="move_id"]').val(response.evento.id_mossa);
    $('.btn-backend-delete').removeClass('d-none');
    $('.actions').removeClass('d-none').addClass('d-flex');
    $('.no-evento').removeClass('d-flex').addClass('d-none');
    $('.form-calendar-content').find('input').prop('readonly',false);
    $('.form-calendar-content').find('textarea').prop('readonly',false);
    $('.form-calendar-content').find('select').removeClass('disabled-select');
    $('.form-calendar-content').find('.switch').removeClass('disabled-select');
    $('#modal-calendar .btn-backend').text('Aggiorna');
    $('input[name="summary"]').val(response.evento.titolo);
    $('textarea[name="description"]').val(response.evento.descrizione);
    $('input[name="start_date"]').val(response.evento.inizio);
    $('input[name="start_time"]').val(response.evento.inizio_time);
    $('input[name="end_date"]').val(response.evento.fine);
    $('input[name="end_time"]').val(response.evento.fine_time);
    $('input[name="location"]').val(response.evento.indirizzo);
    if (response.evento.evento_virtuale == '1') {
        $('input[name="toggle-type-event"]').prop('checked', true);
        $('.event-location-option').addClass('d-none');
        $('.event-hangout-option').removeClass('d-none');
        if(response.evento.link_meet){
            $('.hangout-link').text(response.evento.link_meet);
            $('.hangout-link').attr('href', response.evento.link_meet);
            $('.hangout-link-container').removeClass('d-none');
        }
    } else {
        $('.event-location-option ').removeClass('d-none');
        $('.event-hangout-option').addClass('d-none');
    }

    $('.container-list-attendees').empty();
    $.each(response.evento.partecipanti, function(i,val) { 
        if(val != response.evento.organizzatore){
            $('.container-list-attendees').append('<div class="attendee-email-elem"><div class="remove-attendee-email me-2">x</div><span>' + val + '</span></div>');
        }
    });

    $('#modal-calendar').removeClass('opacity-0');
    if(response.evento.canceled){
        $('#modal-calendar').addClass('disabled');
        $('.form-footer.no-evento').addClass('bg-danger');
        $('.form-footer.no-evento').text('L\'evento è stato rimosso');
    } else {
        $('.form-footer.no-evento').removeClass('bg-danger');
        $('.form-footer.no-evento').text('Non puoi modificare questo evento');
    }
                    
    $('#modal-calendar .form-title').text('Aggiorna Evento');
    try {
        const request = {
            'calendarId': 'primary',
            'eventId': $('input[name="event_id"]').val(),
            'timeMin': (new Date()).toISOString(),
            'showDeleted': false,
            'singleEvents': true
        };

        let response = await gapi.client.calendar.events.get(request);
        if(response.result.status == "cancelled"){
            $('.form-footer.no-evento').removeClass('d-none').addClass('d-flex');
            $('.form-footer.actions').addClass('d-none');
            $('#modal-calendar .form-title').text('Informazioni Evento');
            $('#modal-calendar').addClass('disabled');
        } else {
            $('#modal-calendar').removeClass('disabled');
            $('.form-footer.actions').removeClass('d-none'); 
        }
    } catch(e) {
        $('.actions').addClass('d-none').removeClass('d-flex');
        $('.no-evento').removeClass('d-none').addClass('d-flex');
        $('.form-calendar-content').find('input').prop('readonly',true);
        $('.form-calendar-content').find('textarea').prop('readonly',true);
        $('.form-calendar-content').find('select').addClass('disabled-select');
        $('.form-calendar-content').find('.switch').addClass('disabled-select');
        $('.form-title').text('Dettaglio evento');
        $('.form-footer.actions').addClass('d-none'); 
    }
}